import { render, staticRenderFns } from "./CreateReceiptPaymentDialog.vue?vue&type=template&id=2bdf3f61"
import script from "./CreateReceiptPaymentDialog.vue?vue&type=script&lang=js"
export * from "./CreateReceiptPaymentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports